import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "bg-white",
  style: {"height":"100vh"}
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "p-menuitem-text" }
const _hoisted_4 = {
  key: 1,
  class: "mt-5 border-top-1"
}
const _hoisted_5 = {
  class: "p-menuitem-text",
  style: {"color":"var(--red-500)"}
}
const _hoisted_6 = { class: "w-100 m-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      "show-aside": _ctx.showAside,
      onOnShowAsideChange: _ctx.onShowAsideChange
    }, null, 8, ["show-aside", "onOnShowAsideChange"]),
    _createElementVNode("div", null, [
      _createVNode(_component_Sidebar, {
        visible: _ctx.showAside,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAside) = $event)),
        modal: false,
        style: {"top":"70px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Menu, {
            model: _ctx.sidebarItems,
            class: "w-100"
          }, {
            item: _withCtx(({ item }) => [
              (!item.logout)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.toRoute(item.routeName)),
                    class: "p-menuitem-link",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-menuitem-icon", item.icon])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
                  ], 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout())),
                      class: "p-menuitem-link",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["p-menuitem-icon", item.icon]),
                        style: {"color":"var(--red-500)"}
                      }, null, 2),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode(_component_Toast)
    ])
  ]))
}